import React from 'react'
import {Icon} from '@chakra-ui/react'

const PlusIcon = (props) => {
    return (
        <Icon
            as="svg"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 11 11"
            fill="none"
            {...props}
        >
            <path
                d="M5.41699 0C5.8311 0 6.16683 0.335927 6.16699 0.75V4.66699H10.083C10.4972 4.66699 10.833 5.00278 10.833 5.41699C10.833 5.83121 10.4972 6.16699 10.083 6.16699H6.16699V10.083C6.16699 10.4972 5.83121 10.833 5.41699 10.833C5.00278 10.833 4.66699 10.4972 4.66699 10.083V6.16699H0.75C0.335955 6.16679 0 5.83108 0 5.41699C0 5.0029 0.335955 4.66719 0.75 4.66699H4.66699V0.75C4.66716 0.335927 5.00288 0 5.41699 0Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default PlusIcon
